var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0203 5.47962C6.82504 5.28435 6.50846 5.28435 6.31319 5.47962C6.11793 5.67488 6.11793 5.99146 6.31319 6.18672L7.0203 5.47962ZM9.33341 8.49984L9.68697 8.85339C9.88223 8.65813 9.88223 8.34155 9.68697 8.14628L9.33341 8.49984ZM6.31319 10.813C6.11793 11.0082 6.11793 11.3248 6.31319 11.5201C6.50846 11.7153 6.82504 11.7153 7.0203 11.5201L6.31319 10.813ZM6.31319 6.18672L8.97986 8.85339L9.68697 8.14628L7.0203 5.47962L6.31319 6.18672ZM8.97986 8.14628L6.31319 10.813L7.0203 11.5201L9.68697 8.85339L8.97986 8.14628Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightIcon);
export default __webpack_public_path__ + "static/media/chevron-right-icon.f643f3e2.svg";
export { ForwardRef as ReactComponent };